import * as React from "react";
import type { SVGProps } from "react";

const SvgBriefcase = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22.632"
        height="21.5"
        viewBox="0 0 22.632 21.5"
        {...props}
    >
        <path
            id="briefcase_focus"
            data-name="briefcase focus"
            d="M23.368,7.526H19.974V5.263A2.265,2.265,0,0,0,17.711,3H10.921A2.265,2.265,0,0,0,8.658,5.263V7.526H5.263A2.265,2.265,0,0,0,3,9.789V22.237A2.265,2.265,0,0,0,5.263,24.5H23.368a2.265,2.265,0,0,0,2.263-2.263V9.789A2.265,2.265,0,0,0,23.368,7.526ZM18.842,9.789V22.237H9.789V9.789ZM17.711,5.263V7.526H10.921V5.263ZM5.263,9.789H7.526V22.237H5.263ZM21.105,22.237V9.789h2.263l0,12.447Z"
            transform="translate(-3 -3)"
            fill="currentColor"
        />
    </svg>
);
export default SvgBriefcase;
